// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3ed093b7","455":"47a75fc1","738":"a8cc305a","818":"14ed218e"}[chunkId] + ".chunk.js";
};